module.exports = __webpack_public_path__ + "img/C3.f607bf49.png";